import Annotation from "./annotation";
import { setLineStyle, setFontStyle } from "../canvasUtils";
import { POINTER_CLASSES } from "../../config/config";

export default class SegmentationMeasurement extends Annotation {
  constructor() {
    super();

    this.sliceFit = null;
    this.transform = null;
    this.sliceInfo = null;
    this.measureData = null;

    this.lineWidth = 3;
    this.color = "#00b0f0";
    this.font = "14px Calibri";
    this.baseline = "hanging";

    this.boxWidth = 40;
    this.boxHeight = 10;
    this.triangleLength = 5;

    this.sliderY = null;
    this.canvasSize = null;
  }

  draw(ctx) {
    if (!this.measureData || !this.transform || !this.sliceInfo || !this.sliceFit || !this.canvasSize) return;

    let x = this.convertX(this.measureData.index);
    let h = this.canvasSize.h;

    setLineStyle(ctx, this);
    this.drawSlider(ctx, x, h);

    if (this.measureData.ilm < 0 && this.measureData.rpe < 0) return;

    let ilm = this.convertY(this.measureData.ilm);
    let rpe = this.convertY(this.measureData.rpe);
    this.drawHelperLine(ctx, x, ctx.canvas.height, Math.max(ilm, rpe));

    if (!this.measureData.thickness) return;

    this.drawThicknessLine(ctx, x, ilm, rpe);

    let text = this.measureData.thicknessText;
    this.drawTextBackground(ctx, x, ilm, rpe, text);
    this.drawText(ctx, x, ilm, rpe, text);
  }

  convertX(x){
    let zoom = this.transform.zoom;
    let offsetX = this.transform.offsetX;
    return x * zoom + offsetX;
  }

  convertY(y) {
    let zoom = this.transform.zoom;
    let offsetY = this.transform.offsetY;
    return y * zoom + offsetY;
  }

  drawThicknessLine(ctx, x, ilm, rpe) {
    ctx.beginPath();
    ctx.moveTo(x, ilm);
    ctx.lineTo(x, rpe);
    ctx.stroke();
    ctx.closePath();
  }

  drawHelperLine(ctx, x, bottom, top){
    ctx.setLineDash([3, 10]);
    ctx.beginPath();
    ctx.moveTo(x, bottom);
    ctx.lineTo(x, top + 10);
    ctx.stroke();
    ctx.closePath();
    ctx.setLineDash([]);
  }

  drawSlider(ctx, x, y){
    let w = this.boxWidth;
    let h = this.boxHeight;
    let t = this.triangleLength;
    ctx.fillRect(x - w / 2, y - h, w, h);
    ctx.beginPath();
    ctx.moveTo(x, y - h - t);
    ctx.lineTo(x - t, y - h);
    ctx.lineTo(x + t, y - h);
    ctx.lineTo(x, y - h - t);
    ctx.closePath();
    ctx.stroke();
    ctx.fill();
  }

  drawText(ctx, x, ilm, rpe, text) {
    if (!text) return;
    setFontStyle(ctx, this);
    let y = (ilm + rpe) / 2 - 7;
    let textWidth = ctx.measureText(text).width;
    if (this.sliceFit.w < x + textWidth + 5) x = x - textWidth - 5;
    else x += 5;

    ctx.fillText(text, x, y);
  }

  drawTextBackground(ctx, x, ilm, rpe, text) {
    setFontStyle(ctx, this);
    ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
    let y = (ilm + rpe) / 2 - 10;
    let textWidth = ctx.measureText(text).width;
    if (this.sliceFit.w < x + textWidth + 5) x = x - textWidth - 7;
    else x += 3;
    ctx.fillRect(x, y, textWidth + 4, 18);
  }

  updateTransform(transform) {
    if (this.transform !== transform) this.transform = transform;
    this.signalReady();
  }

  updateSliceInfo(sliceInfo) {
    if (this.sliceInfo !== sliceInfo) this.sliceInfo = sliceInfo;
    this.signalReady();
  }

  updateMeasureData(data) {
    if (this.measureData !== data) this.measureData = data;
    this.signalReady();
  }
  
  updateSliceFit(fit) {
    if (this.sliceFit !== fit) this.sliceFit = fit;
    this.signalReady();
  }

  getHoverClass(x) {
    let index = this.measureData.index;
    if (x > index - 10 && x < index + 10) return POINTER_CLASSES.pointer;
  }
}